// Bootstrap 5.3.3 Configuration and Global Imports
// This file ensures Bootstrap 5.3.3 is properly configured across the entire application

// Import Bootstrap 5.3.3 CSS
import 'bootstrap/dist/css/bootstrap.min.css';

// Import Bootstrap 5.3.3 JavaScript Bundle (includes Popper.js)
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Import Font Awesome 6.5.1 for modern icons
import '@fortawesome/fontawesome-free/css/all.min.css';

// Bootstrap 5.3.3 Utility Classes and Components
export const BootstrapClasses = {
  // Layout
  container: 'container',
  containerFluid: 'container-fluid',
  row: 'row',
  col: 'col',
  
  // Flexbox
  dFlex: 'd-flex',
  justifyContentCenter: 'justify-content-center',
  justifyContentBetween: 'justify-content-between',
  alignItemsCenter: 'align-items-center',
  
  // Spacing (Bootstrap 5.3 spacing system)
  mb1: 'mb-1', mb2: 'mb-2', mb3: 'mb-3', mb4: 'mb-4', mb5: 'mb-5',
  mt1: 'mt-1', mt2: 'mt-2', mt3: 'mt-3', mt4: 'mt-4', mt5: 'mt-5',
  p1: 'p-1', p2: 'p-2', p3: 'p-3', p4: 'p-4', p5: 'p-5',
  
  // Buttons
  btn: 'btn',
  btnPrimary: 'btn btn-primary',
  btnSecondary: 'btn btn-secondary',
  btnSuccess: 'btn btn-success',
  btnDanger: 'btn btn-danger',
  btnWarning: 'btn btn-warning',
  btnInfo: 'btn btn-info',
  btnLight: 'btn btn-light',
  btnDark: 'btn btn-dark',
  btnOutlinePrimary: 'btn btn-outline-primary',
  btnOutlineSecondary: 'btn btn-outline-secondary',
  btnLg: 'btn-lg',
  btnSm: 'btn-sm',
  
  // Forms
  formControl: 'form-control',
  formSelect: 'form-select',
  formCheck: 'form-check',
  formCheckInput: 'form-check-input',
  formCheckLabel: 'form-check-label',
  inputGroup: 'input-group',
  inputGroupText: 'input-group-text',
  
  // Text
  textCenter: 'text-center',
  textStart: 'text-start',
  textEnd: 'text-end',
  textMuted: 'text-muted',
  textPrimary: 'text-primary',
  textSecondary: 'text-secondary',
  textSuccess: 'text-success',
  textDanger: 'text-danger',
  textWarning: 'text-warning',
  textInfo: 'text-info',
  
  // Display
  dNone: 'd-none',
  dBlock: 'd-block',
  dInline: 'd-inline',
  dInlineBlock: 'd-inline-block',
  
  // Width and Height
  w25: 'w-25',
  w50: 'w-50',
  w75: 'w-75',
  w100: 'w-100',
  h25: 'h-25',
  h50: 'h-50',
  h75: 'h-75',
  h100: 'h-100',
  
  // Position
  positionRelative: 'position-relative',
  positionAbsolute: 'position-absolute',
  positionFixed: 'position-fixed',
  positionSticky: 'position-sticky',
  
  // Bootstrap 5.3 Components
  card: 'card',
  cardBody: 'card-body',
  cardHeader: 'card-header',
  cardFooter: 'card-footer',
  cardTitle: 'card-title',
  cardText: 'card-text',
  
  // Modal
  modal: 'modal',
  modalDialog: 'modal-dialog',
  modalContent: 'modal-content',
  modalHeader: 'modal-header',
  modalBody: 'modal-body',
  modalFooter: 'modal-footer',
  modalTitle: 'modal-title',
  
  // Navbar
  navbar: 'navbar',
  navbarExpand: 'navbar-expand-lg',
  navbarBrand: 'navbar-brand',
  navbarNav: 'navbar-nav',
  navItem: 'nav-item',
  navLink: 'nav-link',
  
  // Carousel
  carousel: 'carousel',
  carouselSlide: 'carousel slide',
  carouselInner: 'carousel-inner',
  carouselItem: 'carousel-item',
  carouselItemActive: 'carousel-item active',
  
  // Spinner (Bootstrap 5.3)
  spinnerBorder: 'spinner-border',
  spinnerBorderSm: 'spinner-border spinner-border-sm',
  spinnerGrow: 'spinner-grow',
  spinnerGrowSm: 'spinner-grow spinner-grow-sm',
  
  // Visibility
  visibleHidden: 'visually-hidden',
  
  // Responsive utilities
  dSmNone: 'd-sm-none',
  dMdNone: 'd-md-none',
  dLgNone: 'd-lg-none',
  dXlNone: 'd-xl-none',
  dXxlNone: 'd-xxl-none',
  
  // Margin and Padding responsive
  msAuto: 'ms-auto',
  meAuto: 'me-auto',
  ms1: 'ms-1', ms2: 'ms-2', ms3: 'ms-3', ms4: 'ms-4', ms5: 'ms-5',
  me1: 'me-1', me2: 'me-2', me3: 'me-3', me4: 'me-4', me5: 'me-5',
};

// Bootstrap 5.3.3 Icons (Font Awesome 6.5.1)
export const Icons = {
  // User icons
  user: 'fas fa-user',
  users: 'fas fa-users',
  userCircle: 'fas fa-user-circle',
  
  // Navigation
  home: 'fas fa-home',
  menu: 'fas fa-bars',
  close: 'fas fa-times',
  search: 'fas fa-search',
  
  // Actions
  edit: 'fas fa-edit',
  delete: 'fas fa-trash',
  save: 'fas fa-save',
  cancel: 'fas fa-times',
  check: 'fas fa-check',
  plus: 'fas fa-plus',
  minus: 'fas fa-minus',
  
  // Arrows
  arrowRight: 'fas fa-arrow-right',
  arrowLeft: 'fas fa-arrow-left',
  arrowUp: 'fas fa-arrow-up',
  arrowDown: 'fas fa-arrow-down',
  chevronRight: 'fas fa-chevron-right',
  chevronLeft: 'fas fa-chevron-left',
  
  // Communication
  email: 'fas fa-envelope',
  phone: 'fas fa-phone',
  mobile: 'fas fa-mobile-alt',
  chat: 'fas fa-comments',
  
  // Security
  lock: 'fas fa-lock',
  unlock: 'fas fa-unlock',
  eye: 'fas fa-eye',
  eyeSlash: 'fas fa-eye-slash',
  
  // Media
  camera: 'fas fa-camera',
  image: 'fas fa-image',
  video: 'fas fa-video',
  file: 'fas fa-file',
  folderOpen: 'fas fa-folder-open',
  
  // Status
  checkCircle: 'fas fa-check-circle',
  exclamationTriangle: 'fas fa-exclamation-triangle',
  infoCircle: 'fas fa-info-circle',
  timesCircle: 'fas fa-times-circle',
  
  // Astrology specific
  star: 'fas fa-star',
  moon: 'fas fa-moon',
  sun: 'fas fa-sun',
  magic: 'fas fa-magic',
  crystal: 'fas fa-gem',
  
  // Gender
  venus: 'fas fa-venus',
  mars: 'fas fa-mars',
  venusMars: 'fas fa-venus-mars',
  
  // General
  heart: 'fas fa-heart',
  calendar: 'fas fa-calendar',
  clock: 'fas fa-clock',
  location: 'fas fa-map-marker-alt',
  globe: 'fas fa-globe',
  shield: 'fas fa-shield-alt',
  crown: 'fas fa-crown',
  gift: 'fas fa-gift',
  
  // Loading
  spinner: 'fas fa-spinner',
  circleNotch: 'fas fa-circle-notch',
};

// Bootstrap 5.3.3 Breakpoints
export const Breakpoints = {
  xs: '0px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1400px',
};

// Bootstrap 5.3.3 Color System
export const Colors = {
  primary: '#0d6efd',
  secondary: '#6c757d',
  success: '#198754',
  danger: '#dc3545',
  warning: '#ffc107',
  info: '#0dcaf0',
  light: '#f8f9fa',
  dark: '#212529',
  white: '#ffffff',
  black: '#000000',
};

// Helper function to combine classes
export const combineClasses = (...classes) => {
  return classes.filter(Boolean).join(' ');
};

// Initialize Bootstrap tooltips and popovers
export const initializeBootstrap = () => {
  // Initialize tooltips
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => 
    new window.bootstrap.Tooltip(tooltipTriggerEl)
  );

  // Initialize popovers
  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
  const popoverList = [...popoverTriggerList].map(popoverTriggerEl => 
    new window.bootstrap.Popover(popoverTriggerEl)
  );

  return { tooltipList, popoverList };
};

export default {
  BootstrapClasses,
  Icons,
  Breakpoints,
  Colors,
  combineClasses,
  initializeBootstrap,
}; 